/**
 * Hardware Secure Decode Robustness.
 *
 *
 * @beta
 */
export const HW_SECURE_DECODE = 'HW_SECURE_DECODE'
